import React from "react";
import { Modal } from "react-bootstrap";

export default function Welcome({ nextSlide, skip, skipping }) {
  return (
    <Modal.Body className="welcome-slide height100">
      <div className="wrapper">
        <h1>Please Share Your Feedback!</h1>
        <p className="mt20">
          Help us improve and keep the quality of each session at the highest
          level. Your comments are private and visible to LeggUP only. We'd be
          so grateful, it will only take a minute.
        </p>
        {!skipping && (
          <>
            <a className="mt20 btn btn-white btn-outline" onClick={nextSlide}>
              Let's start
            </a>
            <div className="mt10">or</div>
          </>
        )}
        <a
          className="mt10 btn btn-white btn-outline"
          onClick={() => skip({ type: "session_feedback" })}
        >
          {skipping ? "Please, wait ..." : "Skip All"}
        </a>
      </div>
    </Modal.Body>
  );
}
